import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGrit} from "../TrueGrit";
import {TimelineLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TrueGritStatics} from "../TrueGritStatics";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {MathUtils} from "../utils/MathUtils";
import {Device} from "@nolimitcity/slot-launcher/bin/interfaces/APIOptions";

/**
 * Created by Jerker Nord on 2021-11-16.
 */

export class TrueGritLuckyDrawView extends PIXI.Container implements StageLayer {
    private _luckyDrawTL: TimelineLite;
    private _flippers: PIXI.Sprite[] = [];

    constructor() {
        super();
        this.name = "TrueGritLuckyDrawView";
        this.init();
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds,
            darkBg: PIXI.Graphics = new PIXI.Graphics();

        darkBg.clear();
        darkBg.beginFill(0x000000, 0.7);
        darkBg.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        darkBg.endFill();
        // negate the effect of TrueGritStatics.MAIN_REELS_VIEW_POSITION
        darkBg.position.set(14, -192);

        this.addChildAt(darkBg, 0); // always put dark bg at 0.

        this.position.y = 0;
        if (!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + bounds.top) / 2;
        }
    }

    // #475 -> modified
    public getLuckyDrawTL(): TimelineLite {
        const startWIth: number = MathUtils.randomIntFromInterval(0, 1),
            flip1: PIXI.Sprite = this._flippers[startWIth],
            flip2: PIXI.Sprite = (startWIth === 0 ? this._flippers[1] : this._flippers[0]),
            duration: number = 0.2;

        this._luckyDrawTL = new TimelineLite();

        flip1.alpha = 0;
        flip1.visible = true;
        flip2.alpha = 0;
        flip2.visible = true;
        this.alpha = 0;
        this.visible = true;

        this._luckyDrawTL.to(this, {
            duration: duration,
            alpha: 1
        });
        for (let i: number = 0; i < MathUtils.randomIntFromInterval(2, 4); i++) {
            this._luckyDrawTL.to(flip1, {
                duration: duration,
                alpha: 1
            });
            this._luckyDrawTL.to(flip1, {
                duration: duration,
                alpha: 0
            });
            this._luckyDrawTL.to(flip2, {
                duration: duration,
                alpha: 1
            });
            this._luckyDrawTL.to(flip2, {
                duration: duration,
                alpha: 0
            });
        }
        this._luckyDrawTL.to(this, {
            duration: 0.5,
            alpha: 0,
            onComplete: () => {
                flip1.visible = false;
                flip2.visible = false;
                this.visible = false;
            }
        }, "-=0.5"); // so that flipping is still going on but we are fading everything as per #475

        return this._luckyDrawTL;
    }

    private init() {
        TrueGrit.winPresentations.addChild(this);
        this.visible = false;

        const logo: PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("luckyDraw/luckyDrawLogo")[0]);
        logo.anchor.set(0.5);
        logo.position.set(360, 50);

        const fs: PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("luckyDraw/fs")[0]);
        fs.anchor.set(0.5);
        fs.position.set(181, 250);

        const fsSelect: PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("luckyDraw/fs_select")[0]);
        fsSelect.anchor.set(0.5);
        fsSelect.position.set(181, 246);

        const sfs: PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("luckyDraw/sfs")[0]);
        sfs.anchor.set(0.5);
        sfs.position.set(531, 250);

        const sfsSelect: PIXI.Sprite = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("luckyDraw/sfs_select")[0]);
        sfsSelect.anchor.set(0.5);
        sfsSelect.position.x = 535;
        // due to difference in asset load quality
        if (TrueGrit.apiPlugin.options.device === Device.DESKTOP) {
            sfsSelect.position.y = 246;
        } else {
            sfsSelect.position.y = 247.5;
        }

        this._flippers.push(fsSelect, sfsSelect);
        this.addChild(logo, fs, fsSelect, sfs, sfsSelect);

        this.onResize();
    }
}